import { useQuery } from '@tanstack/react-query'
import { getCustomerMeta } from 'pages/admin/common/adminDatastore'

export const useGetCustomerMeta = (customerIds) => {
  const query = useQuery(['fetchCustomerMeta'], async () => getCustomerMeta(customerIds), {
    retry: 2,
    refetchInterval: false,
    refetchOnWindowFocus: false
  })

  return { metadata: query.data?.metadata ?? {}, query }
}
